import React from 'react';
import { View, StyleSheet } from 'react-native';
import { Text } from '@/components/common/text';
import { REDESIGN_TYPOGRAPHY } from '@/constants/residents/homeConstants';
import { SVG_COMPONENTS } from '@/assets/admin';
import { RESIDENTS_SVG_COMPONENTS } from '@/assets/residents';
import { useThemeColors } from '@/hooks/residents/useThemeColors';

const ThumbUpIcon = SVG_COMPONENTS.THUMB_UP;
const StartConvoIcon = RESIDENTS_SVG_COMPONENTS.START_CONVO;

export type ChatGlassEmptyStateType = 'noMessages' | 'startConversation';

interface ChatGlassEmptyStateProps {
  type: ChatGlassEmptyStateType;
}

const EMPTY_STATE_CONFIG = {
  noMessages: {
    title: 'No messages',
    subtitle: 'You have no messages at the moment',
    Icon: ThumbUpIcon,
    iconSize: { width: 68, height: 68 },
  },
  startConversation: {
    title: 'Start conversation',
    subtitle: 'Enter subject, then type your message.',
    Icon: StartConvoIcon,
    iconSize: { width: 77, height: 68 },
  },
};

export const ChatGlassEmptyState: React.FC<ChatGlassEmptyStateProps> = React.memo(({ type }) => {
  const { colors } = useThemeColors();
  const config = EMPTY_STATE_CONFIG[type];
  const { Icon, iconSize, title, subtitle } = config;

  return (
    <View style={styles.container}>
      <View style={styles.iconContainer}>
        <Icon
          width={iconSize.width}
          height={iconSize.height}
          color={colors.text.subtle}
        />
      </View>
      <View style={styles.textContainer}>
        <Text style={[styles.title, { color: colors.text.primary }]}>{title}</Text>
        <Text style={[styles.subtitle, { color: colors.text.subtle }]}>{subtitle}</Text>
      </View>
    </View>
  );
});

ChatGlassEmptyState.displayName = 'ChatGlassEmptyState';

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    paddingTop: 68,
    paddingHorizontal: 24,
  },
  iconContainer: {
    marginBottom: 18,
  },
  textContainer: {
    alignItems: 'center',
    gap: 6,
    width: 240,
  },
  title: {
    ...REDESIGN_TYPOGRAPHY.cardTitleLarge,
    textAlign: 'center',
  },
  subtitle: {
    ...REDESIGN_TYPOGRAPHY.body,
    textAlign: 'center',
  },
});
